import { Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { colors } from '../../../utils/colors';
import { MdDeleteForever, MdModeEdit } from 'react-icons/md';
import DoNotDisturbAltIcon from '@mui/icons-material/DoNotDisturbAlt';

export const VerEmpleadosCapacitacionModal = ({ 
    open,
    setOpenEditarEmpleado,
    setOpen,
    deleteEmpleado
}) => {

    // * DESESTRUCTURACION DE LOS DATOS.
    const { capacitacion, open: openModal, capacitacion : { empleados } } = open;
    
  return (
    <Dialog
    PaperProps={{ sx: { width: "70%", height: "80%" } }}
    open={openModal}
    maxWidth='lg'
    >
        <DialogTitle sx={{textTransform: 'uppercase'}} className='text-mem text-center'>Empleados de la Capacitación - {capacitacion.descripcion}</DialogTitle>
        <Divider />

        <DialogContent>

            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                <b>Empleado</b>
                            </TableCell>
                            <TableCell>
                                <b>Grado Alcanzado</b>
                            </TableCell>
                            <TableCell>
                                <b>Nombre de Grado Alcanzado</b>
                            </TableCell>
                            <TableCell>

                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            empleados?.length > 0 ?
                                empleados.map((item, index) => (
                                    <TableRow key={index}>
                                        <TableCell>
                                            {item.nombre}
                                        </TableCell>
                                        <TableCell>
                                            {item.gradoAlcanzado.descripcion}
                                        </TableCell>
                                        <TableCell>
                                            {item.nombreGradoAlcanzado}
                                        </TableCell>
                                        <TableCell>
                                            <IconButton onClick={() => setOpenEditarEmpleado({ edit: true, open: true, empleado: item})}>
                                                <MdModeEdit color={colors.azulMem} fontSize={22} />
                                            </IconButton>
                                            <IconButton>
                                                <MdDeleteForever onClick={() => deleteEmpleado(item)} color='red' fontSize={22} />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))
                            :
                            <></>
                        }
                    </TableBody>
                </Table>
            </TableContainer>

           

        </DialogContent>

        <DialogActions className='justify-content-center'>
            <button type='button'onClick={() => {
                setOpen({ open: false, edit: false, capacitacion: {}});
            }} className='btn btn-danger'><DoNotDisturbAltIcon sx={{marginTop: -0.5, marginRight: 0.5}} />CANCELAR</button>
        </DialogActions>

    </Dialog>
  )
}
